import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Phone, MapPin } from 'lucide-react';
export function FamilyHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-1080">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1081">
        <Users className="w-4 h-4" data-id="element-1082" />
        Family Martial Arts
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-1083">
        <span className="text-gold tracking-wider shrink-0" data-id="element-1084">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-1085">|</span>
        <span className="shrink-0" data-id="element-1086">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-1087">
        Family Martial Arts & Family Taekwondo Classes in Farmington Hills
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-1088">
        Storm Taekwondo gives parents and kids a positive way to train together,
        stay active, build confidence, and grow as a family.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-1089">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-1090">
          Start a Family Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary flex items-center justify-center gap-2" data-id="element-1091">
          <Phone className="w-5 h-5" data-id="element-1092" />
          Call 517-220-0621
        </a>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-1093">
        <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-1094" />
        <p data-id="element-1095">
          24786 Crestview, Farmington Hills, MI 48335 — serving Commerce, Walled
          Lake, Wixom, Novi, Northville, Livonia, White Lake, Waterford,
          Milford, West Bloomfield, Farmington & beyond.
        </p>
      </div>
    </div>;
}